import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

import SurveyList from '../../sections/employee/surveys/SurveyList';
import SurveyStatistics from '../../sections/employee/surveys/SurveyStatistics';


export default function SurveyDetails() {
  const { id } = useParams();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page title="Ankieta">
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
        <Tab icon={<ListAltIcon />} label="Wypełnione ankiety" iconPosition="start" value={0}/>
        <Tab icon={<LeaderboardIcon />} label="Statystyki" iconPosition="start" value={1}/>
      </Tabs>
      {value === 0 ? <SurveyList id={id}/> : null}
      {value === 1 ? <SurveyStatistics id={id}/> : null}
    </Page>
  );
};
